<template>
    <section>

        <div>
            <b-modal :active="isModalNewEditExtendPhaseUnit" aria-modal has-modal-card :destroy-on-hide="true"
                aria-role="dialog" width="100%" :can-cancel="['escape']">
                <template>
                    <ModalNewEditExtendPhaseTerm modal-cancel="true" :update="update" :create="create"
                        :extendPhaseTerm="selectedExtendPhaseTerm" :performancePhaseId="phaseActive.id"
                        @close="isModalNewEditExtendPhaseUnit = false; create = false; update = false; selectedExtendPhaseTerm = {}"
                        @refresh="getExtendPhaseTerms()" />
                </template>
            </b-modal>

            <b-modal :active="isModalNewExtendPhaseAcademic" aria-modal has-modal-card :destroy-on-hide="true"
                aria-role="dialog" width="100%" :can-cancel="['escape']">
                <template>
                    <ModalNewExtendPhaseTermAcademics modal-cancel="true" :performancePhaseId="phaseActive.id"
                        @close="isModalNewExtendPhaseAcademic = false" @refresh="getExtendPhaseTerms()" />
                </template>
            </b-modal>

            <b-modal :active="isModalEditExtendPhaseAcademic" aria-modal has-modal-card :destroy-on-hide="true"
                aria-role="dialog" width="100%" :can-cancel="['escape']">
                <template>
                    <ModalEditExtendPhaseTermAcademic modal-cancel="true" :extendPhaseTerm="selectedExtendPhaseTerm"
                        @close="isModalEditExtendPhaseAcademic = false; selectedExtendPhaseTerm = {}"
                        @refresh="getExtendPhaseTerms()" />
                </template>
            </b-modal>
        </div>

        <div class="container box mt-5">

            <div class="content mb-6 has-text-centered">

                <h1>
                    Ampliar Plazo de Declaración del Cuerpo Académico {{ phaseActive.year }}
                </h1>

                <h3 class="mt-0">
                    Fase Actual: {{ phaseActive.name }}
                </h3>

            </div>

            <b-tabs type="is-toggle" position="is-centered">
                <b-tab-item label="Unidades con Ampliación">
                    <div class="columns">
                        <div class="column has-text-right">
                            <b-button label="Ampliar Plazo de Declaración de una Unidad" type="is-purple-color-usach"
                                icon-left="users-cog" @click="create = true; isModalNewEditExtendPhaseUnit = true" />
                        </div>
                    </div>

                    <b-tabs position="is-centered">
                        <b-tab-item label="Plazos Activos">
                            <b-table :data="extendPhaseTerms.filter(x => x.enable && x.is_unit)" paginated per-page=10
                                :pagination-simple=false pagination-position="bottom" aria-next-label="Siguiente"
                                aria-previous-label="Anterior" aria-page-label="Página"
                                aria-current-label="Página actual" striped>
                                <b-table-column label="Unidad" field="unit_name" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Unidad..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.unit_name }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="CC" field="unit_cc" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]" placeholder="Buscar CC..."
                                            icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.unit_cc }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Apertura" field="start_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.start_date._isValid ? new
                                            Date(props.row.start_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Cierre" field="end_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.end_date._isValid ? new
                                            Date(props.row.end_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Acciones" width="15%" v-slot="props">
                                    <b-button type="is-primary" icon-left="eye" tag="a" target="_blank" />
                                    <b-button type="is-warning" icon-left="edit"
                                        @click="selectedExtendPhaseTerm = props.row; update = true; isModalNewEditExtendPhaseUnit = true" />
                                    <b-button type="is-danger" icon-left="trash"
                                        @click="confirmDisableExtendPhaseTerm(props.row.id)" />
                                </b-table-column>

                                <template slot="empty" slot-scope="props">
                                    <div class="columns is-centered">
                                        <div class="column is-6 is-centered has-text-centered">
                                            <b-message type="is-warning">
                                                No se han encontrado Plazos Activos para Unidades.
                                            </b-message>
                                        </div>
                                    </div>
                                </template>
                            </b-table>
                        </b-tab-item>

                        <b-tab-item label="Plazos Anulados">
                            <b-table :data="extendPhaseTerms.filter(x => (x.enable === false) && x.is_unit)" paginated
                                per-page=10 :pagination-simple=false pagination-position="bottom"
                                aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                                aria-current-label="Página actual" striped>
                                <b-table-column label="Unidad" field="unit_name" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Unidad..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.unit_name }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="CC" field="unit_cc" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]" placeholder="Buscar CC..."
                                            icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.unit_cc }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Apertura" field="start_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.start_date._isValid ? new
                                            Date(props.row.start_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Cierre" field="end_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.end_date._isValid ? new
                                            Date(props.row.end_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Acciones" width="15%" v-slot="props">
                                    <b-button type="is-primary" icon-left="eye" tag="a" target="_blank" />
                                </b-table-column>

                                <template slot="empty" slot-scope="props">
                                    <div class="columns is-centered">
                                        <div class="column is-6 is-centered has-text-centered">
                                            <b-message type="is-warning">
                                                No se han encontrado Plazos Activos para Unidades.
                                            </b-message>
                                        </div>
                                    </div>
                                </template>
                            </b-table>
                        </b-tab-item>
                    </b-tabs>
                </b-tab-item>

                <b-tab-item label="Académicos/as con Ampliación">
                    <div class="columns">
                        <div class="column has-text-right">
                            <b-button label="Ampliar Plazo de Declaración de un/a Académico/a"
                                type="is-purple-color-usach" icon-left="users-cog"
                                @click="isModalNewExtendPhaseAcademic = true" />
                        </div>
                    </div>

                    <b-tabs position="is-centered">
                        <b-tab-item label="Plazos Activos">
                            <b-table :data="extendPhaseTerms.filter(x => x.enable && x.is_unit === false)" paginated
                                per-page=10 :pagination-simple=false pagination-position="bottom"
                                aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                                aria-current-label="Página actual" striped>
                                <b-table-column label="Nombre" field="academic_name" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Nombre..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.academic_name }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="RUT" field="academic_rut" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]" placeholder="Buscar RUT..."
                                            icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.academic_rut }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Unidad" field="academic_unit" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Unidad..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.academic_unit }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Apertura" field="start_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.start_date._isValid ? new
                                            Date(props.row.start_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Cierre" field="end_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.end_date._isValid ? new
                                            Date(props.row.end_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Acciones" width="15%" v-slot="props">
                                    <b-button type="is-primary" icon-left="eye" tag="a" target="_blank"
                                        :href="`/performances/process/${props.row.performance_phase_year}/person/${props.row.id_object}`" />
                                    <b-button type="is-warning" icon-left="edit"
                                        @click="selectedExtendPhaseTerm = props.row; isModalEditExtendPhaseAcademic = true" />
                                    <b-button type="is-danger" icon-left="trash"
                                        @click="confirmDisableExtendPhaseTerm(props.row.id)" />
                                </b-table-column>

                                <template slot="empty" slot-scope="props">
                                    <div class="columns is-centered">
                                        <div class="column is-6 is-centered has-text-centered">
                                            <b-message type="is-warning">
                                                No se han encontrado Plazos Activos para Académicos/as.
                                            </b-message>
                                        </div>
                                    </div>
                                </template>
                            </b-table>
                        </b-tab-item>

                        <b-tab-item label="Plazos Anulados">
                            <b-table :data="extendPhaseTerms.filter(x => x.enable === false && x.is_unit === false)"
                                paginated per-page=10 :pagination-simple=false pagination-position="bottom"
                                aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                                aria-current-label="Página actual" striped>
                                <b-table-column label="Nombre" field="academic_name" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Nombre..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.academic_name }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="RUT" field="academic_rut" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]" placeholder="Buscar RUT..."
                                            icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.academic_rut }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Unidad" field="academic_unit" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Unidad..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.academic_unit }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Apertura" field="start_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.start_date._isValid ? new
                                            Date(props.row.start_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Fecha de Cierre" field="end_date" sortable searchable>
                                    <template #searchable="props">
                                        <b-input v-model="props.filters[props.column.field]"
                                            placeholder="Buscar Fecha..." icon="search" />
                                    </template>
                                    <template v-slot="props">
                                        {{ props.row.end_date._isValid ? new
                                            Date(props.row.end_date).toLocaleDateString("es-CL") : '' }}
                                    </template>
                                </b-table-column>

                                <b-table-column label="Acciones" width="15%" v-slot="props">
                                    <b-button type="is-primary" icon-left="eye" tag="a" target="_blank"
                                        :href="`/performances/process/${props.row.performance_phase_year}/person/${props.row.id_object}`" />
                                </b-table-column>

                                <template slot="empty" slot-scope="props">
                                    <div class="columns is-centered">
                                        <div class="column is-6 is-centered has-text-centered">
                                            <b-message type="is-warning">
                                                No se han encontrado Plazos Anulados para Académicos/as.
                                            </b-message>
                                        </div>
                                    </div>
                                </template>
                            </b-table>
                        </b-tab-item>
                    </b-tabs>
                </b-tab-item>
            </b-tabs>
        </div>

        <b-loading is-full-page v-model="isLoading" />

    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import ModalNewEditExtendPhaseTerm from './ModalNewEditExtendPhaseTerm.vue';
import ModalNewExtendPhaseTermAcademics from './ModalNewExtendPhaseTermAcademics.vue';
import ModalEditExtendPhaseTermAcademic from './ModalEditExtendPhaseTermAcademic.vue';
export default {
    name: 'ManageExtendPhaseTerm',

    components: {
        ModalNewEditExtendPhaseTerm,
        ModalNewExtendPhaseTermAcademics,
        ModalEditExtendPhaseTermAcademic,
    },

    props: {
        isPhaseActive: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            isLoading: false,

            isModalNewEditExtendPhaseUnit: false,
            isModalNewExtendPhaseAcademic: false,
            isModalEditExtendPhaseAcademic: false,
            create: false,
            update: false,
            selectedExtendPhaseTerm: {},

            //Datos a Traer
            extendPhaseTerms: [],
            phaseActive: {},
        }
    },

    async created() {

        if (this.isPhaseActive === false) {
            this.$buefy.dialog.alert({
                title: 'Error',
                message: 'En estos momentos no se encuentra una Fase activa, vuelva en otro momento.',
                type: 'is-danger',
                hasIcon: true,
                iconPack: 'fa',
                icon: 'times-circle',
                confirmText: 'Ok',
                onConfirm: () => {
                    window.location.href = '/'
                }
            })
        } else {
            await this.getExtendPhaseTerms();
        }
    },

    methods: {
        async getExtendPhaseTerms() {
            this.isLoading = true;
            await axios
                .get('/extend_phase_terms.json')
                .then(response => {
                    this.extendPhaseTerms = response.data.extend_phase_terms;
                    this.extendPhaseTerms.forEach(element => {
                        element.start_date = moment(element.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"]);
                        element.end_date = moment(element.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"]);
                    });
                    this.phaseActive = response.data.phase;
                    this.phaseActive.start_date = moment(this.phaseActive.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                    this.phaseActive.end_date = moment(this.phaseActive.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer los Plazos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        async confirmDisableExtendPhaseTerm(id) {
            this.$buefy.dialog.confirm({
                title: 'Confirmar',
                message: '¿Está seguro de Anular el Plazo?',
                type: 'is-warning',
                hasIcon: true,
                icon: 'exclamation-triangle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
                onConfirm: async () => {
                    await this.disableExtendPhaseTerm(id);
                }
            })
        },

        async disableExtendPhaseTerm(id) {
            this.isLoading = true;
            await axios
                .put(`/extend_phase_terms/${id}/enable-disable.json`)
                .then(response => {
                    this.extendPhaseTerms = this.extendPhaseTerms.map(extendPhaseTerm => {
                        if (extendPhaseTerm.id === id) {
                            extendPhaseTerm.enabled = !extendPhaseTerm.enabled;
                        }
                        return extendPhaseTerm;
                    });
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al Habilitar/Deshabilitar el Plazo. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>